<template>
  <div>
    <base-header class="pb-6">
      <b-row v-show="false" class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <issues-types-form-edit
              :issuesTypes="issuesTypesParameter"
              v-if="issuesTypesParameter.title"
            ></issues-types-form-edit>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import IssuesTypesFormEdit from "./IssuesTypesFormEdit/IssuesTypesFormEdit.vue";
export default {
  name: "issues-form",
  components: {
    IssuesTypesFormEdit
  },
  data() {
    return {
      issuesTypesParameter: {
        title: null,
        description: null,
        id: null
      }
    };
  },
  created() {},
  mounted() {
    if (this.$route.params.issuesTypes) {
      console.log("parametros issuestypes", this.$route.params.issuesTypes);
      this.issuesTypesParameter.title = this.$route.params.issuesTypes.label;
      this.issuesTypesParameter.description = this.$route.params.issuesTypes.description;
      this.issuesTypesParameter.id = this.$route.params.issuesTypes.id;
    } else {
      this.$router.push("/issuesTypes");
      return;
    }
  }
};
</script>
